// packages/shared-hooks/src/users/usePatchUser.ts
// Spec §18, §14.4. PATCH /users/:id with the minimal diff; invalidates both
// the list (to reflect the updated row) and the detail (so a re-open of the
// drawer shows authoritative server state).
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserSchema, type PatchUserInput, type User } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function usePatchUser(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<User, unknown, PatchUserInput>({
    mutationFn: (input) => client.patch<User>(`/users/${id}`, input, {}, UserSchema),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['users', 'list'] });
      qc.invalidateQueries({ queryKey: ['user', id] });
    },
  });
}
